<small class="debug">{{me}}</small>
<div class="animSettings">
    <div class="row">
        <span class="col1" style="position: relative; top: 5px; left: 10px;">animation</span>
        <div class="col2">
            <mat-radio-group fxLayout="column">
                <mat-radio-button (click)="removeAnimationSlice($event)" [checked]="showAnimationEngine !== 1" value="0">
                    <span>{{'general.inherit' | transloco}}</span>&nbsp;&nbsp;
                </mat-radio-button>
                <mat-radio-button (click)="createAnimationSlice()" [checked]="showAnimationEngine === 1" value="1">
                    <span>{{'general.override' | transloco}}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    @if (showAnimationEngine === 1) {
        <div class="animation-preview">
            <app-block-animation-preview></app-block-animation-preview>
        </div>
        <br/>
    }
    <!-- @if (showAnimationEngine === 1) {
        <div class="row">
            <div fxLayout="row" class="d-flex-center">
                <button mat-icon-button class="mini-button" matTooltip="{{'general.copyAnimation' | transloco}}"
                    (click)="copyAnimation();">
                    <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button class="mini-button" matTooltip="{{'general.pasteAnimation' | transloco}}"
                    (click)="pasteAnimation();" [disabled]="!animationClipboard">
                    <mat-icon>content_paste</mat-icon>
                </button>
                @if (isHostDevOrLocal) {
                    <button mat-icon-button class="mini-button" (click)="devExportConfig()">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                }
            </div>
        </div>
    } -->
</div>